import { useAuthorizedIntegrationContext } from '@shared/contexts/pluginContexts/AuthorizedIntegrationContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRefreshAuthorization = () => {
  const { refetch } = useAuthorizedIntegrationContext();
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshAuthorization = async () => {
    setIsRefreshing(true);
    try {
      await refetch();
      navigate('/');
    } catch {
      setIsRefreshing(false);
    }
  };

  return { isRefreshing, refreshAuthorization };
};
